import axiosInstance from '../api';
import {
  CommentLikeRequest,
  CommentLikeResponse,
  CommentUnlikeResponse,
  CommentLikesCountResponse,
  CommentLikersResponse,
  CommentLikeStatusResponse
} from './commentLikeApi.types';

/**
 * コメントに「いいね」する
 * @param comment_id - コメントID
 * @returns いいね作成結果
 */
export const likeComment = async (comment_id: string): Promise<CommentLikeResponse> => {
  const response = await axiosInstance.post<CommentLikeResponse>(
    '/comment-likes', 
    { comment_id }, 
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  return response.data;
};

/**
 * コメントの「いいね」を取り消す
 * @param comment_id - コメントID
 * @returns 取り消し結果
 */
export const unlikeComment = async (comment_id: string): Promise<CommentUnlikeResponse> => {
  const response = await axiosInstance.delete<CommentUnlikeResponse>('/comment-likes', {
    params: { comment_id }
  });
  return response.data;
};

/**
 * コメントの「いいね」数を取得する
 * @param comment_id - コメントID
 * @returns いいね数
 */
export const getCommentLikesCount = async (comment_id: string): Promise<CommentLikesCountResponse> => {
  const response = await axiosInstance.get<CommentLikesCountResponse>('/comment-likes/count', {
    params: { comment_id }
  });
  return response.data;
};

/**
 * コメントを「いいね」したユーザー一覧を取得する
 * @param comment_id - コメントID
 * @returns いいねしたユーザー一覧
 */
export const getCommentLikers = async (comment_id: string): Promise<CommentLikersResponse> => {
  const response = await axiosInstance.get<CommentLikersResponse>('/comment-likes/likers', {
    params: { comment_id }
  });
  return response.data;
};

/**
 * 現在のユーザーのコメントいいね状態を取得する
 * @param comment_id - コメントID
 * @returns いいね状態
 */
export const getCommentLikeStatus = async (comment_id: string): Promise<CommentLikeStatusResponse> => {
  const response = await axiosInstance.get<CommentLikeStatusResponse>('/comment-likes/status', {
    params: { comment_id }
  });
  return response.data;
}; 